"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = require("../stores/notifications");
var _kernel_container_1 = __importDefault(require("../../container"));
function removeNotification(notificationId) {
    var action = function (dispatch) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/removeNotification");
        logger.debug("Got request to remove notification", { notificationId: notificationId });
        dispatch((0, notifications_1.removeNotification)(notificationId));
    };
    action.type = removeNotification.type;
    return action;
}
removeNotification.type = "removeNotification";
exports.default = removeNotification;
//# sourceMappingURL=removeNotification.js.map